// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-6502c323] {\n  list-style: none;\n}[dir] .item[data-v-6502c323] {\n  cursor: pointer;\n}\n.wrap-table[data-v-6502c323] {\n  max-height: 600px;\n  overflow-y: auto;\n}\n.groups[data-v-6502c323] {\n  height: 750px;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
